import { createFileRoute } from "@tanstack/react-router"
import { zodValidator } from "@tanstack/zod-adapter"

import { InventoryAdjustmentHistoryListPage } from "@/screens/Inventory/subfeatures/InventoryAdjustmentHistory/components"
import { inventoryAdjustmentHistorySearchSchema } from "@/screens/Inventory/subfeatures/InventoryAdjustmentHistory/schemas"

export const Route = createFileRoute("/app/inventory/_layout/adjustment-history")({
  validateSearch: zodValidator(inventoryAdjustmentHistorySearchSchema),
  component: () => <InventoryAdjustmentHistoryListPage />,
})
